import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

interface Params {
  user: number;
  roles: number[];
}

/** PATCH `/user/user_role/bulk/` — sets a user's full set of Roles in one call. */
export const useBulkUpdateUserRoles = () => {
  const { authHeader } = useAuth();

  return useMutation((params: Params) => {
    return axios.patch(`${env.verifyServiceUrl}user/user_role/bulk/`, params, {
      headers: {
        Authorization: authHeader,
      },
    });
  });
};
